var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5245 4.46352C13.6741 4.00287 14.3259 4.00287 14.4755 4.46353L15.4593 7.49139C15.5263 7.6974 15.7183 7.83688 15.9349 7.83688H19.1186C19.6029 7.83688 19.8043 8.45669 19.4124 8.74139L16.8368 10.6127C16.6615 10.74 16.5882 10.9657 16.6552 11.1717L17.639 14.1996C17.7886 14.6602 17.2614 15.0433 16.8695 14.7586L14.2939 12.8873C14.1186 12.76 13.8814 12.76 13.7061 12.8873L11.1305 14.7586C10.7386 15.0433 10.2114 14.6602 10.361 14.1996L11.3448 11.1717C11.4118 10.9657 11.3385 10.74 11.1632 10.6127L8.58755 8.74139C8.1957 8.45669 8.39708 7.83688 8.88145 7.83688H12.0651C12.2817 7.83688 12.4737 7.6974 12.5407 7.49139L13.5245 4.46352Z",
    fill: "#FFD460"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.380371,
    y: 0.118164,
    width: 27.239,
    height: 26.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.831373 0 0 0 0 0.376471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d10ec13a5426a8bd5ffa47f58509dd8f.svg";
export { ForwardRef as ReactComponent };